import { useEffect, useState } from "react";
import { toast } from "sonner";
import { MapPin } from "lucide-react";
import { api } from "../../lib/api";

// CEO 2026-10-07 · Admin : réattribue la zone (=> coordinateur) d'un candidat en 1 clic.
export default function RegionReassignCard({ candidate, onChanged }) {
    const [options, setOptions] = useState([]);
    const [saving, setSaving] = useState(false);
    const current = candidate.layan_offer_region || "";
    const override = candidate.region_manual_override;

    useEffect(() => {
        api.get("/candidates-regions/options")
            .then(({ data }) => setOptions(data.items || []))
            .catch(() => setOptions([]));
    }, []);

    const onSelect = async (value) => {
        if (!value || value === current) return;
        setSaving(true);
        try {
            await api.patch(`/candidates/${candidate.id}/region`, { region: value });
            toast.success(`Zone mise à jour : ${value}`);
            onChanged?.();
        } catch (err) {
            toast.error(err.response?.data?.detail || "Impossible de changer la zone");
        } finally {
            setSaving(false);
        }
    };

    const coords = options.find((o) => o.value === current)?.coordinators || [];

    return (
        <div className="card-soft p-6" data-testid="region-reassign-card">
            <h3 className="text-sm font-extrabold uppercase tracking-widest text-slate-400 mb-3 inline-flex items-center gap-1.5">
                <MapPin className="h-4 w-4" /> Zone coordinateur
            </h3>
            <select
                value={current}
                disabled={saving}
                onChange={(e) => onSelect(e.target.value)}
                className="w-full h-10 px-3 rounded-xl border border-shariti-gray bg-white text-sm font-bold"
                data-testid="region-reassign-select"
            >
                {!current && <option value="">— Zone non déterminée —</option>}
                {current && !options.some((o) => o.value === current) && <option value={current}>{current}</option>}
                {options.map((o) => (
                    <option key={o.value} value={o.value}>
                        {o.label}{o.coordinators.length ? ` · ${o.coordinators.join(", ")}` : ""}
                    </option>
                ))}
            </select>
            <p className="mt-2 text-[11px] text-slate-500" data-testid="region-reassign-coordinators">
                {coords.length ? `Visible par : ${coords.join(", ")}` : "Aucun coordinateur sur cette zone."}
                {override?.by_name && ` · Modifiée manuellement par ${override.by_name}`}
            </p>
        </div>
    );
}
